// MP-OS-196: the monthly report draws its OWN trend. It used to capture the Sales Trends
// chart, so a June report carried that chart's segment, filters, brands, cumulative/index
// mode and window, which ends at the data end (a June PDF ran to October as "Other").
// Built only from the report's own state: the report month and the chosen supplier (or the
// whole market). Never from Sales Trends state.
import { fetchDosTrend, formatRangeLabel, type Period } from '../landing'
import type { Chart } from '../types'

// MPD-133 L6: when the report's trend request fails or returns nothing, the note next to the report
// button and the PDF's line in the trend's place (never a silent omission).
export const REPORT_TREND_UNAVAILABLE = 'Trend unavailable; the PDF is created without it.'
export const REPORT_TREND_UNAVAILABLE_PDF = 'Trend unavailable: the trend for this report could not be loaded. The figures above are unchanged.'

// The months the report trend covers, ending with the report month.
export const REPORT_TREND_MONTHS = 6

export interface ReportSupplier {
  manufacturer: string // '' = the whole market
  label: string
}

export interface MonthlyReportTrendRequest {
  from: string
  to: string
  freq: 'week'
  manufacturer: string
}

export interface MonthlyReportData {
  request: MonthlyReportTrendRequest
  caption: string
}

/**
 * The report trend: the supplier's full CU (no segment, filters or brands), weekly, for the
 * six months ending at the report month's end, or at its "through" date while the month is
 * ongoing, and never before the first date the data covers.
 */
export function monthlyReportData(period: Period, supplier: ReportSupplier, dataStart?: string): MonthlyReportData {
  const [year, month] = period.value.split('-').map(Number)
  const first = new Date(Date.UTC(year, month - REPORT_TREND_MONTHS, 1)).toISOString().slice(0, 10)
  const from = dataStart && first < dataStart ? dataStart : first
  const to = period.ongoing && period.through ? period.through : period.to
  return {
    request: { from, to, freq: 'week', manufacturer: supplier.manufacturer },
    caption: `CU · ${formatRangeLabel(from, to)} · ${supplier.manufacturer ? supplier.label : 'All suppliers'}`,
  }
}

export function fetchMonthlyReportTrend(request: MonthlyReportTrendRequest): Promise<Chart | null> {
  return fetchDosTrend(request)
}
